import { userManager } from '@/Core/Managers'

import { CLIENT_COST_FIELDS } from '../Contracts/ClientFieldLabels'
import { LoadDefaultCurrencyTask } from './LoadDefaultCurrencyTask'

import type { ClientFormContextLike } from '../Contracts/IClient'

const isBlank = (value: unknown): boolean =>
    value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0)

/**
 * Поточний користувач — значенням поля «Відповідальний».
 *
 * Select ядра впізнає вибране за `@id`, а бек приймає зв'язок за IRI, тож без
 * `@id` будуємо його з `uuid` — так само, як його будує колекція
 * співробітників.
 */
const currentUserRef = (): Record<string, unknown> | null => {
    const user = userManager.user as Record<string, unknown>
    const uuid = typeof user['uuid'] === 'string' ? user['uuid'] : null

    if (!uuid) return null

    return { ...user, '@id': typeof user['@id'] === 'string' ? user['@id'] : `/services/users/${uuid}`, uuid }
}

/**
 * Значення форми створення клієнта (`SPEC-009` §5.1):
 *
 *  - **«Відповідальний» — той, хто створює** (КЛ-02): у легасі так робила
 *    сторінка (`ClientPage.jsx:60-64`), і бек тепер вимагає хоча б одного;
 *  - **валюта трьох сум — EUR** (КЛ-08): той самий дефолт ставить і бек, але
 *    без нього у формі валюта стояла б порожньою, і людина не бачила б, у
 *    чому вводить суму.
 *
 * Пише лише в порожні поля й через `setInitialValue`: форма, у якій людина
 * вже щось вибрала, не перезаписується, а значення за замовчуванням не
 * рахується незбереженою зміною.
 */
export const ApplyClientCreateDefaultsTask = async (formContext: ClientFormContextLike): Promise<void> => {
    const values = formContext.values ?? {}

    if (isBlank(values['responsibles'])) {
        const user = currentUserRef()

        if (user) formContext.setInitialValue?.('responsibles', [user])
    }

    const currency = await LoadDefaultCurrencyTask()

    if (!currency) return

    for (const { currency: field } of CLIENT_COST_FIELDS) {
        if (isBlank(formContext.values?.[field])) formContext.setInitialValue?.(field, currency)
    }
}
